import { render, staticRenderFns } from "./VotingProgress.vue?vue&type=template&id=65c11b8f"
import script from "./VotingProgress.vue?vue&type=script&lang=js"
export * from "./VotingProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports